module.exports = __webpack_public_path__ + "static/media/wordpress.1df0c1a2.webp";